import { ClassFlag } from "../../../dom-tools/ClassFlag";
import { ElementType } from "../../../dom-tools/ElementType";
import { HTMLEditor } from "../../../dom-tools/HTMLEditor";
import { MultiString } from "../../../i18n/MultiString";
import { SortText } from "../../../text/SortText";
import { DataType } from "../../evaluators/DataType";
import { Evaluator } from "../../evaluators/Evaluator";
import { DataTypes } from "./Library/DataTypes";
import { LomaEvaluator } from "./LomaEvaluator";
import { LomaFunction } from "./LomaFunction";
import { LomaInfo } from "./LomaInfo";
import { LomaVariable } from "./LomaVariable";
import { Stringifier, StringifierOptions } from "./Stringifier";

export enum LomaDocEntryType
{
  VARIABLE,
  FUNCTION
}

export class LomaDocEntry<T extends LomaInfo>
{
  type:LomaDocEntryType;
  referenced:T;
  info:MultiString;

}

export class LomaDoc
{ 
  static readonly type = new ElementType( "loma--doc" );
  static readonly entry   = new ElementType( "loma--entry" );
  static readonly header  = new ElementType( "loma--header" );

  static readonly headerName = new ElementType( "loma--header--name" );
  static readonly operator = new ElementType( "loma--operator" );
  static readonly parameterName = new ElementType( "loma--parameter--name" );
  static readonly dataType = new ElementType( "loma--data--type" );
  static readonly dataValue = new ElementType( "loma--data--value" );
  static readonly hoverOnly = new ClassFlag( "hover--only" );

  static readonly info = new ElementType( "loma--info" );


  entries:LomaDocEntry<LomaInfo>[] = [];
  

  createHTML()
  { 
    let htmlOutput = LomaDoc.type.create();
    this.entries.forEach( e => 
      {
        htmlOutput.appendChild( ElementType.break.create() );
        htmlOutput.appendChild( this._createHTMLEntry( e ) );
        
      }
    );

    console.log( htmlOutput );
    return htmlOutput;
  }

  _createHTMLEntry( entry:LomaDocEntry<LomaInfo> )
  {
    let info   = LomaDoc.info.create();
    let header = LomaDoc.header.create();

    
    LomaDoc.hoverOnly.set( info );

    let entryElement = LomaDoc.entry.create( [ header, ElementType.break.create(), info ] );

    
    header.appendChild( LomaDoc.headerName.create( entry.referenced.getInfoTitle() ) ) ;

    if ( LomaDocEntryType.FUNCTION === entry.type )
    { 
      let func = entry.referenced as LomaFunction;

      header.appendChild( LomaDoc.operator.create( "( " ) );

      for ( let i = 0; i < func.parameters.length; i++ )
      {
        if ( i !== 0 )
        {
          header.appendChild( LomaDoc.operator.create( ", " ) );
        }

        let p = func.parameters[ i ];

        if ( p.variadic )
        {
          header.appendChild( LomaDoc.operator.create( "..." ) );
        }

        header.appendChild( LomaDoc.parameterName.create( p.parameterName ) );
        header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.operator.create( ":" ) ) );
        header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.dataType.create( p.type.name ) ) );
        

        if ( p.variadic )
        {
          header.appendChild( LomaDoc.operator.create( "[]" ) );
        }

        if ( p.optional)
        {
          header.appendChild( LomaDoc.operator.create( " = " ) );
          header.appendChild( LomaDoc.dataValue.create( Stringifier.stringify( p.defaultValue, p.type ) ) );
        }

      }

      header.appendChild( LomaDoc.operator.create( " )" ) );
      
      header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.operator.create( ":" ) ) );
      header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.dataType.create( func.returnType.name ) ) );
    }
    else if ( LomaDocEntryType.VARIABLE === entry.type )
    {
      let variable = entry.referenced as LomaVariable<any>;
      
      header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.operator.create( ":" ) ) );
      header.appendChild( LomaDoc.hoverOnly.set( LomaDoc.dataType.create( variable.type.name )  )  );

      header.appendChild( LomaDoc.operator.create( " = " ) );
      header.appendChild( LomaDoc.dataValue.create( 
        Stringifier.stringify( 
          variable.value, DataTypes.Number, StringifierOptions.createWithRounding( 8 ) )
        ) 
      );
    }

    if ( entry.info )
    {

      HTMLEditor.setText( info, MultiString.resolve( entry.info ) );
    }
    
    return entryElement;
  }

  createFrom( evaluator:LomaEvaluator )
  {
    this._addFunctions( evaluator );
    this._addVariables( evaluator );

    SortText.sort( this.entries, e => e.referenced.getInfoTitle().toLowerCase() );

  } 

  _addFunctions( evaluator:LomaEvaluator )
  {
    for ( let vk of evaluator._functions )
    {
      console.log( vk );
      let functions = vk[ 1 ];

      for ( let f of functions )
      {
        let entry = new LomaDocEntry<LomaFunction>();
        entry.type = LomaDocEntryType.FUNCTION;
        entry.referenced = f;
        entry.info = f.info;

        this.entries.push( entry );
      }

    }

  }
  
  _addVariables( evaluator:LomaEvaluator )
  {
    for ( let vk of evaluator._variables )
    {
      console.log( vk );

      let variable = vk[ 1 ];
      
      let entry = new LomaDocEntry<LomaVariable<any>>();
      entry.type = LomaDocEntryType.VARIABLE;
      entry.referenced = variable;
      entry.info = variable.info;

      this.entries.push( entry );
    }

  }

}